export default {
  venueTypes: [],
  venueType: undefined,
};
